<script lang="ts">
import { defineComponent, PropType, inject } from 'vue'
import StepWrapper from './StepWrapper.vue'

export default defineComponent({
  name: 'ListingStatusStep',

  components: {
    StepWrapper,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    listingStatus: {
      type: Object as PropType<InputText>,
      required: true,
    },
  },

  emits: ['update:listingStatus', 'click:prev', 'click:next'],

  setup(_, { emit }) {
    const LISTING_STATUSES = inject<string[]>('LISTING_STATUSES')!

    const next = () => {
      emit('click:next')
    }

    return {
      // constants
      LISTING_STATUSES,

      // methods
      next,
    }
  },
})
</script>

<template>
  <StepWrapper
    :namespace="namespace"
    :input-scheme="listingStatus"
    category-label="上場区分"
    :category-items="LISTING_STATUSES"
    @update:model-value="$emit('update:listingStatus', $event)"
    @click:prev="$emit('click:prev')"
    @click:next="$emit('click:next')" />
</template>
